import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { Box, Button, Card, Heading, Text } from '@myxplor/stardust'

import sortObjectsBy from '~/src/utils/sortObjectsBy'

import { AccountDetail } from './types'
import ServiceModal from './ServiceModal'

interface Props {
  account: AccountDetail
}

const LINK_STYLE = {
  color: 'inherit',
  textDecoration: 'none',
  width: '100%',
}

const ApiKeyList = ({ account }: Props) => {
  const [createdServices, setCreatedServices] = useState<Papi.Service[]>([])
  const [isModalOpen, setModalOpen] = useState<boolean>(false)

  const onServiceAdd = () => {
    setModalOpen(true)
  }

  const onServiceSave = async (service: Papi.Service) => {
    setCreatedServices((services) => [...services, service])
    setModalOpen(false)
  }

  const services = sortObjectsBy([...createdServices, ...account.services], 'id')

  return (
    <Card>
      <Box display="flex" flexDirection="column">
        <Box alignItems="center" display="flex" justifyContent="space-between" padding="small">
          <Heading level={5}>Services</Heading>
          <Button onClick={onServiceAdd}>Add Service</Button>
        </Box>
        {services.length === 0 && (
          <Box borderColor="lowestEmphasis" border="1px solid" padding="small">
            <Text>No Services</Text>
          </Box>
        )}
        {services.map((service) => (
          <Link key={service.id} to={`/services/${service.id}`} style={LINK_STYLE}>
            <Box
              alignItems="center"
              borderTop="1px solid"
              borderColor="lowerEmphasis"
              cursor="pointer"
              display="flex"
              hoverStyle={({ theme }) => ({ backgroundColor: theme.colors.lowestEmphasis })}
              justifyContent="space-between"
              padding="small"
              transition="background-color .2s"
              width={1}>
              <Box display="flex" flexDirection="column" flexGrow={1} paddingRight="small">
                <Text prefab="body">{service.name}</Text>
              </Box>
              <Box display="flex" flexDirection="column">
                <Text align="right" prefab="overline">
                  ID
                </Text>
                <Text align="right" lineHeight={1.4} prefab="bodyAlt">
                  {service.id}
                </Text>
              </Box>
            </Box>
          </Link>
        ))}
      </Box>
      <ServiceModal
        account={account}
        isOpen={isModalOpen}
        onCancel={() => setModalOpen(false)}
        onSave={onServiceSave}
      />
    </Card>
  )
}

export default React.memo(ApiKeyList)
